import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import { MetricTableVizData, MetricTableVizExternalProps } from '../../types';
import { metricTableViewDataToUiComponentProps } from './dataToUiComponentProps';
import {
  MetricTableViewActions,
  MetricTableViewState,
  MetricTableViewUiComponentProps,
} from './types';
import { MetricTableViewUiComponent } from './UiComponent';
import { useMetricTableViewStateManager } from './useStateManager';

export const metricTableViewConfig: DataVizContainerViewConfigWithStateManager<
  MetricTableVizData,
  MetricTableVizExternalProps,
  MetricTableViewUiComponentProps,
  MetricTableViewState,
  MetricTableViewActions
> = {
  hasStateManager: true,
  useStateManager: useMetricTableViewStateManager,
  dataToUiComponentProps: metricTableViewDataToUiComponentProps,
  UiComponent: MetricTableViewUiComponent,
};
